import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, CalendarIcon, UserIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { MarkdownRenderer } from '../components/MarkdownRenderer';
import { getPostBySlug, formatDate } from '../data/blogPosts';
export const BlogPostPage: React.FC = () => {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const post = slug ? getPostBySlug(slug) : undefined;
  if (!post) {
    return <Navigate to="/blog" replace data-id="element-199" />;
  }
  return <div className="min-h-screen flex flex-col bg-background" data-id="element-200">
      <Helmet data-id="element-201">
        <title data-id="element-202">{post.title} - IBD Rant</title>
        <meta name="description" content={post.excerpt} data-id="element-203" />
        <meta property="og:type" content="article" data-id="element-204" />
        <meta property="og:title" content={post.title} data-id="element-205" />
        <meta property="og:description" content={post.excerpt} data-id="element-206" />
        {post.mainImage && <meta property="og:image" content={post.mainImage} data-id="element-207" />}
        <meta name="twitter:card" content="summary_large_image" data-id="element-208" />
        <meta name="twitter:title" content={post.title} data-id="element-209" />
        <meta name="twitter:description" content={post.excerpt} data-id="element-210" />
        {post.mainImage && <meta name="twitter:image" content={post.mainImage} data-id="element-211" />}
      </Helmet>
      <Header data-id="element-212" />
      <main className="flex-grow py-12 px-4 bg-background" data-id="element-213">
        <article className="max-w-3xl mx-auto" data-id="element-214">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-215">
            <Link to="/blog" className="inline-flex items-center gap-2 text-primary hover:text-primary-dark transition-colors mb-8" data-id="element-216">
              <ArrowLeftIcon className="h-4 w-4" data-id="element-217" />
              Back to Blog
            </Link>

            <header className="mb-8" data-id="element-218">
              {post.mainImage && <div className="w-full overflow-hidden rounded-lg bg-gray-900 mb-8 flex items-center justify-center p-6" data-id="element-219">
                  <img src={post.mainImage} alt={post.title} className="max-w-full h-auto rounded-lg" data-id="element-220" />
                </div>}
              <div className="flex items-center gap-4 text-sm text-text-secondary mb-4" data-id="element-221">
                <div className="flex items-center gap-2" data-id="element-222">
                  <CalendarIcon className="h-4 w-4" data-id="element-223" />
                  <time dateTime={post.publishedAt} data-id="element-224">
                    {formatDate(post.publishedAt)}
                  </time>
                </div>
                <div className="flex items-center gap-2" data-id="element-225">
                  <UserIcon className="h-4 w-4" data-id="element-226" />
                  <span data-id="element-227">{post.author.name}</span>
                </div>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-228">
                {post.title}
              </h1>
            </header>

            <MarkdownRenderer content={post.content} data-id="element-229" />

            <footer className="mt-12 pt-8 border-t-2 border-gray-800" data-id="element-230">
              <Link to="/blog" className="inline-flex items-center gap-2 bg-primary text-background px-6 py-3 rounded-lg font-semibold hover:bg-opacity-90 transition-all" data-id="element-231">
                <ArrowLeftIcon className="h-4 w-4" data-id="element-232" />
                Back to Blog
              </Link>
            </footer>
          </motion.div>
        </article>
      </main>
      <Footer data-id="element-233" />
    </div>;
};